'use client'

export { default } from '@luxfi/ui/auth-callback'
